/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import "./ConfirmScreenOneDevolucao.css"

import { Descriptions, Image } from "antd"
import React, { useEffect, useState } from "react"

import { fileListToBase64, toCPF, toReadableBoolean } from "../../../helpers/format"
import { type ApplicationState } from "../../../store"

interface OwnProps {
  formData: ApplicationState["onefleetdevolucao"]
}

const ConfirmScreenOneDevolucao = (props: OwnProps): React.ReactElement => {
  const {
    car,
    client,
    consultant,
    damagedOrMissingItems,
    images,
    signatures
  } = props.formData.data

  const {
    accessories,
    accessoryStatus
  } = props.formData

  const [descriptionsLayout, setDescriptionsLayout] = useState<"horizontal" | "vertical">("horizontal")
  const [formatedAccessoryImages, setFormatedAccessoryImages] = useState<any>({})
  const [licensePlateBase64, setLicensePlateBase64] = useState<Array<{ key: string, base64: string }>>([])
  const [odometerBase64, setOdometerBase64] = useState<Array<{ key: string, base64: string }>>([])
  const [carFrontBase64, setCarFrontBase64] = useState<Array<{ key: string, base64: string }>>([])
  const [carRightBase64, setCarRightBase64] = useState<Array<{ key: string, base64: string }>>([])
  const [carBackBase64, setCarBackBase64] = useState<Array<{ key: string, base64: string }>>([])
  const [carLeftBase64, setCarLeftBase64] = useState<Array<{ key: string, base64: string }>>([])
  const [clientPictureBase64, setClientPictureBase64] = useState<{ key: string, base64: string }>({ base64: "", key: "" })
  const [cnhPictureBase64, setCNHPictureBase64] = useState<{ key: string, base64: string }>({ base64: "", key: "" })

  window.addEventListener("resize", () => {
    if (window.innerWidth <= 600) setDescriptionsLayout("vertical")
    else setDescriptionsLayout("horizontal")
  }, false)

  useEffect(() => {
    const formatImages = async () => {
      const accessoryImages = damagedOrMissingItems?.images
      const formatedAccessoryImages: any = {}

      if (car?.hasDamageOrMissingItems && accessoryImages) {
        for (const [code, files] of Object.entries(accessoryImages)) {
          formatedAccessoryImages[code] = await fileListToBase64(files)
        }

        setFormatedAccessoryImages(formatedAccessoryImages)
      }

      if (images?.licensePlateFileList?.length) setLicensePlateBase64(await fileListToBase64(images.licensePlateFileList))
      if (images?.odometerFileList?.length) setOdometerBase64(await fileListToBase64(images.odometerFileList))
      if (images?.carFrontFileList?.length) setCarFrontBase64(await fileListToBase64(images.carFrontFileList))
      if (images?.carRightFileList?.length) setCarRightBase64(await fileListToBase64(images.carRightFileList))
      if (images?.carBackFileList?.length) setCarBackBase64(await fileListToBase64(images.carBackFileList))
      if (images?.carLeftFileList?.length) setCarLeftBase64(await fileListToBase64(images.carLeftFileList))
      if (signatures?.clientPicture) setClientPictureBase64((await fileListToBase64([signatures.clientPicture]))[0])
      if (signatures.clientCNH) setCNHPictureBase64((await fileListToBase64([signatures.clientCNH]))[0])
    }

    formatImages().catch(err => { console.warn(err) })
  }, [])

  return (
    <div className="onefleet-form-visualization">
      <h3>Representante</h3>
      <Descriptions
        bordered
        size="small"
        column={{ xs: 3 }}
        layout={descriptionsLayout}
      >
        <Descriptions.Item span={3} label="Empresa">{client?.company}</Descriptions.Item>
        <Descriptions.Item span={3} label="Nome">{client?.name}</Descriptions.Item>
        <Descriptions.Item span={3} label="CPF">{toCPF(client?.cpf)}</Descriptions.Item>
        <Descriptions.Item span={3} label="Telefone">{`+${client?.phoneCountryCode.code} ${client?.phone}`}</Descriptions.Item>
        <Descriptions.Item span={3} label="E-mail">{client?.email}</Descriptions.Item>
      </Descriptions>

      <h3>Consultor</h3>
      <Descriptions
        bordered
        size="small"
        column={{ xs: 3 }}
        layout={descriptionsLayout}
      >
        <Descriptions.Item span={3} label="Concessionária">{consultant?.dealer}</Descriptions.Item>
        <Descriptions.Item span={3} label="Cidade/UF">{consultant?.cityAndState}</Descriptions.Item>
        <Descriptions.Item span={3} label="Nome">{consultant?.name}</Descriptions.Item>
        <Descriptions.Item span={3} label="Telefone">{`+${consultant?.phoneCountryCode.code} ${consultant?.phone}`}</Descriptions.Item>
        <Descriptions.Item span={3} label="E-mail">{consultant?.email}</Descriptions.Item>
      </Descriptions>

      <h3>Veículo</h3>
      <Descriptions
        bordered
        size="small"
        column={{ xs: 3 }}
        layout={descriptionsLayout}
      >
        <Descriptions.Item span={3} label="Placa">{car?.licensePlate}</Descriptions.Item>
        <Descriptions.Item span={3} label="Modelo">{car?.model}</Descriptions.Item>
        <Descriptions.Item span={3} label="Km atual">{car?.carKm}</Descriptions.Item>
        <Descriptions.Item span={3} label="Data de devolução">{car?.returnDate.format("DD/MM/YYYY HH:mm")}</Descriptions.Item>
        <Descriptions.Item span={3} label="Apresenta avarias ou itens faltantes?">{toReadableBoolean(car?.hasDamageOrMissingItems)}</Descriptions.Item>
      </Descriptions>

      {
        car?.hasDamageOrMissingItems && (
          <>
            <h3>Acessórios</h3>
            <Descriptions
              bordered
              size="small"
              column={{ xs: 3 }}
              layout={descriptionsLayout}
            >
              {
                accessories.map(accessory => {
                  const currentStatus = damagedOrMissingItems.accessoriesStatus![accessory.code]

                  return (<Descriptions.Item span={3} label={accessory.name} key={accessory.code}>{accessoryStatus.find(status => status.code === currentStatus)?.name}</Descriptions.Item>)
                })
              }
              {
                Object.entries<any>(formatedAccessoryImages ?? {}).map(([code, files]) => {
                  return (<Descriptions.Item span={3} key={code} label={accessories.find(accessory => accessory.code === Number(code))?.name}>{
                    files.map((file: any) => <Image className="onedevolucao-review-image" src={file.base64} key={file.key} />)
                  }</Descriptions.Item>)
                })
              }
            <Descriptions.Item span={3} label="Descrição das avarias">{damagedOrMissingItems.carProblemDescription}</Descriptions.Item>
            </Descriptions>
          </>
        )
      }

      <h3>Imagens</h3>
      <Descriptions
        bordered
        size="small"
        column={{ xs: 3 }}
        layout={descriptionsLayout}
      >
        <Descriptions.Item span={3} label="Foto da placa do veículo">{ licensePlateBase64.map(file => <Image className="onedevolucao-review-image" src={file.base64} key={file.key}/>) }</Descriptions.Item>
        <Descriptions.Item span={3} label="Foto do odômetro">{ odometerBase64.map(file => <Image className="onedevolucao-review-image" src={file.base64} key={file.key}/>) }</Descriptions.Item>
        <Descriptions.Item span={3} label="Foto frontal do veículo">{ carFrontBase64.map(file => <Image className="onedevolucao-review-image" src={file.base64} key={file.key}/>) }</Descriptions.Item>
        <Descriptions.Item span={3} label="Foto da lateral esquerda do veículo">{ carLeftBase64.map(file => <Image className="onedevolucao-review-image" src={file.base64} key={file.key}/>) }</Descriptions.Item>
        <Descriptions.Item span={3} label="Foto da lateral direita do veículo">{ carRightBase64.map(file => <Image className="onedevolucao-review-image" src={file.base64} key={file.key}/>) }</Descriptions.Item>
        <Descriptions.Item span={3} label="Foto da traseira do veículo">{ carBackBase64.map(file => <Image className="onedevolucao-review-image" src={file.base64} key={file.key}/>) }</Descriptions.Item>
      </Descriptions>

      <h3>Assinaturas</h3>
      <Descriptions
        bordered
        size="small"
        column={{ xs: 3 }}
        layout={descriptionsLayout}
      >
        <Descriptions.Item span={3} label="Foto do Representante"><Image className="onedevolucao-review-image" src={clientPictureBase64.base64} key={clientPictureBase64.key}/></Descriptions.Item>
        <Descriptions.Item span={3} label="CNH do Representante"><Image className="onedevolucao-review-image" src={cnhPictureBase64.base64} key={cnhPictureBase64.key}/></Descriptions.Item>

        <Descriptions.Item span={3} label="Assinatura do Representante"><Image className="onedevolucao-review-image" src={signatures?.clientSignatureImage}/></Descriptions.Item>
        <Descriptions.Item span={3} label="Assinatura do consultor"><Image className="onedevolucao-review-image" src={signatures?.consultantSignatureImage}/></Descriptions.Item>
      </Descriptions>
    </div>
  )
}

export default ConfirmScreenOneDevolucao
